
export class OrderVote
{
    constructor({ rootNode })
    {
        this.rootNode = rootNode;
        this.init();
    }

    init()
    {
        this.signedParameters = this.rootNode.dataset.signedParameters;
        this.formNode = this.getEntity('form');

        if (this.formNode) {
            this.form = new VoteForm({
                rootNode: this.formNode
            });
    
            this.formNode.addEventListener('submit', (event) => {
                event.preventDefault();
                this.send();
            });
        }
    }

    prepareData()
    {
        const data = new FormData(this.formNode);

        [...this.formNode.elements]
            .filter(el => el.tagName === 'INPUT' && el.type === 'submit')
            .forEach(({ name, value }) => {
                data.append(name, value);
            });

        return data;
    }

    send()
    {
        $(this.formNode).preloader('show');
        
        this.sendRequest().then(result => {
            this.processResult(result);
        })
        .finally(() => {
            $(this.rootNode).preloader('hide');
        });
    }

    processResult(result)
    {
        const node = BX.Tag.render`<div>${ result }</div>`;
        const newRoot = node.querySelector('[data-entity="order-vote"]');
        if (!newRoot) {
            return;
        }

        BX.Dom.replace(this.rootNode, newRoot);
        setTimeout(() => {
            this.rootNode = newRoot;
            this.init();
        });
    }

    sendRequest()
    {
        const url = this.formNode.getAttribute('action') || window.location.href;
        const method = 'POST';
        const data = this.prepareData();
        const signedParameters = this.signedParameters;

        return new Promise((resolve, reject) => {
            BX.ajax({
                url,
                method,
                data,
                preparePost: false,
                onsuccess: resolve,
                onfailure: reject
            });
        });
    }

    getEntity(entityName)
    {
        return this.rootNode.querySelector(`[data-entity="${entityName}"]`)
    }
}

export class VoteForm
{
    constructor({ rootNode })
    {
        this.rootNode = rootNode;

        this.init();
        this.bindEvents();
    }

    init()
    {
        this.values = {};
        this.questions = [];

        this.getAllEntities('question')
            .forEach(node => {
                const id = node.dataset.questionId;
                const conditions = BX.parseJSON(node.dataset.conditions);
                const isText = !!node.dataset.isText;

                this.values[id] = this.getValue(id);

                this.questions.push({
                    node,
                    conditions,
                    isText,
                    visited: false
                });
            });
        
        this.questions
            .filter(({ conditions }) => !this.checkConditions(conditions))
            .map(({ node }) => node)
            .forEach(BX.Dom.hide)
    }

    checkConditions(conditions) 
    {
        if (!conditions) {
            return true;
        }

        for (let id in conditions) {
            if (!conditions.hasOwnProperty(id)) {
                continue;
            }

            let value = this.values[id];

            if (!value.find(val => conditions[id].includes(val))) {
                return false;
            }
        }

        return true;
    }

    bindEvents()
    {
        this.rootNode.querySelectorAll(`[data-field]`)
            .forEach(node => node.addEventListener('change', e => this.updateValue(node)));
    }

    getValue(id)
    {
        const values = [];
        const elements = this.rootNode.querySelectorAll(`[data-field="${id}"]`);

        elements.forEach(element => {
            switch(element.type) {
                case 'checkbox':
                case 'radio':
                    if (element.checked) {
                        values.push(element.value);
                    }
                    break;
                default:
                    values.push(element.value);
                    break;
            }
        });

        return elements.length > 1 ? values : values.pop();
    }

    updateValue(node)
    {
        this.values[node.dataset.field] = this.getValue(node.dataset.field);
        this.update();
    }

    update()
    {
        this.questions
            .filter(({ conditions }) => this.checkConditions(conditions))
            .map(({ node }) => node)
            .forEach(BX.Dom.show)

        this.questions
            .filter(({ conditions }) => !this.checkConditions(conditions))
            .map(({ node }) => node)
            .forEach(BX.Dom.hide)
    }

    getAllEntities(entityName)
    {
        return this.rootNode.querySelectorAll(`[data-entity="${entityName}"]`);
    }

    getEntity(entityName)
    {
        return this.rootNode.querySelector(`[data-entity="${entityName}"]`)
    }
}